import { useState } from "react";
import ContentSection from "@/pages/Dashboard/ConfigPanel/ContentSection";
import GroupSection from "@/pages/Dashboard/ConfigPanel/GroupSection";
import MiscSection from "@/pages/Dashboard/ConfigPanel/MiscSection";
import { FileText, Users, Settings } from "lucide-react";

const tabs = ["content", "group", "misc"] as const;

export default function ConfigPanel({
  contents,
  miscConfig,
  groups,
  selectedGroups,
  refresh,
  preview = false
}: {
  contents: any[];
  miscConfig: any;
  groups: any[];
  selectedGroups: string[];
  refresh: () => void;
  preview?: boolean;
}) {
  const [active, setActive] = useState<"content" | "group" | "misc">("content");

  const tabConfig = {
    content: { icon: FileText, label: "内容管理" },
    group: { icon: Users, label: "群组管理" },
    misc: { icon: Settings, label: "执行时间" }
  };

  return (
    <div className="user-card user-config-panel">
      <div className="user-segmented-tabs" role="tablist" aria-label="打卡配置分类">
        {tabs.map((tab) => {
          const { icon: Icon, label } = tabConfig[tab];
          return (
            <button
              key={tab}
              id={`user-config-tab-${tab}`}
              onClick={() => setActive(tab)}
              onKeyDown={(event) => {
                const position = tabs.indexOf(tab);
                const next = event.key === "ArrowRight" ? (position + 1) % tabs.length : event.key === "ArrowLeft" ? (position + tabs.length - 1) % tabs.length : event.key === "Home" ? 0 : event.key === "End" ? tabs.length - 1 : -1;
                if (next < 0) return;
                event.preventDefault();
                setActive(tabs[next]);
                document.getElementById(`user-config-tab-${tabs[next]}`)?.focus();
              }}
              className={active === tab ? "is-active" : ""}
              role="tab"
              tabIndex={active === tab ? 0 : -1}
              aria-controls="user-config-tabpanel"
              aria-selected={active === tab}
            >
              <Icon className="w-4 h-4 flex-shrink-0" />
              <span>{label}</span>
            </button>
          );
        })}
      </div>

      <div id="user-config-tabpanel" className="user-config-content" role="tabpanel" aria-labelledby={`user-config-tab-${active}`}>
        {active === "content" && <ContentSection contents={contents} refresh={refresh} preview={preview} />}
        {active === "group" && <GroupSection groups={groups} selectedGroups={selectedGroups} refresh={refresh} preview={preview} />}
        {active === "misc" && <MiscSection config={miscConfig} refresh={refresh} preview={preview} />}
      </div>
    </div>
  );
}
